const themeMap = {
    broker: () =>
        import(
            /* webpackChunkName: "modules/md-copy-right/broker" */ './broker/index.vue'
        )
};

function init(Vue, store) {
    let compFn = themeMap['broker'];
    compFn()
        .then(comp => comp.default)
        .then(comConfig => {
            let copyRight = new Vue({
                ...comConfig,
                propsData: {
                    showCopyright: true
                },
                store
            }).$mount();
            document.body.appendChild(copyRight.$el);
        });
}

export default init;
